<template>
  <div>
    <div class="el-section eu-justify_center eu-flex">
      <div class="emd-container eu-flex-item eu-basis_12 eu-basis_8_md">
        <div class="emd-container__content eu-pa_5_md eu-flex eu-justify_center emd-text _align_center">
          <div class="eu-flex-item eu-basis_12 eu-basis_12_md eu-mb_4">
            <i class="uil uil-check-circle check-icon"></i>
          </div>
          <div class="eu-flex-item eu-basis_12 eu-basis_12_md eu-mb_5">
            <span class="success-title">{{ $t('title') }} {{ total }}</span>
          </div>
          <div class="eu-flex-item eu-basis_12 eu-basis_12_md eu-mb_5">
            <span class="success-subtitle">{{ $t('subtitle') }}</span>
          </div>
          <div class="eu-flex-item eu-basis_12 eu-basis_9_md eu-mb_5">
            <div class="el-chunk eu-align-items_center">
              <div class="emd-container _type_card">
                <div class="emd-container__content">
                  <div class="emd-copy eu-justify_center eu-align-items_center eu-row_md">
                    <p class="emd-copy__text eu-grow_0 eu-basis_8_md" ref="payment_link">
                      {{ paymentLinkData.url }}
                    </p>
                    <button class="emd-btn _color_primary _block_mobile eu-ml_4 eu-basis_3_md" @click="copy('payment_link')" :class="{ '_copied': copied }">
                      <div v-if="!copied">
                        <i class="uil uil-copy"></i>
                        {{ $t('copy') }}
                      </div>
                      <div v-if="copied">
                        <i class="uil uil-check-circle"></i>
                        {{ $t('copied') }}
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="eu-flex-item eu-basis_12 eu-basis_12_md eu-justify_center eu-flex eu-mb_5">
            <a class="emd-input-icon__link whatsapp-button" :href="$sanitize(whatsappUrl)">
              <i class="uil uil-whatsapp"></i>
              {{ $t('whatsapp') }}
            </a>
          </div>
        </div>
        <hr class="emd-divider" />
        <section class="el-section">
          <div class="eu-flex eu-justify_space-between">
            <a class="emd-btn _type_text _color_secondary eu-ml_4" :href="$sanitize(viewOrder)" target="_blank" rel="noopener noreferrer">
              {{ $t('linkDetails') }}
              <i class="uil uil-arrow-up-right"></i>
            </a>
            <button class="emd-btn _color_secondary eu-mr_4" @click="createNewLink">
              {{ $t('newLink') }}
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, formatToInt } from '@/utils/validations'

export default {
  name: 'Success',
  data () {
    return {
      copied: false
    }
  },
  computed: {
    whatsappUrl () {
      return `https://wa.me/?text=Olá! ${this.$store.getters.accountData.name} gerou um link de pagamento para você no valor de ${this.total}. Acesse o endereço abaixo e pague como preferir.%0A%0A${this.paymentLinkData.url}`
    },
    paymentLinkData () {
      return this.$store.getters.paymentLinkData
    },
    shipping () {
      return this.$store.getters.paymentLinkShipping
    },
    items () {
      return this.$store.getters.paymentLinkItems
    },
    subtotal () {
      const items = this.items
      let sum = 0

      items.forEach(item => {
        sum = sum + this.subtotalItem(item)
      })

      return formatCurrency(sum)
    },
    total () {
      const shipping = formatToInt(this.shipping)
      const subtotal = formatToInt(this.subtotal)

      return formatCurrency((shipping + subtotal) / 100)
    },
    accountId () {
      return this.$store.getters.accountData.id
    },
    merchantId () {
      return this.$store.getters.merchantData.id
    },
    viewOrder () {
      return `${process.env.VUE_APP_DASH_URL}/${this.merchantId}/${this.accountId}/payment-links/${this.paymentLinkData.order_id}`
    }
  },
  methods: {
    subtotalItem (item) {
      if (item.default_quantity && item.amount) {
        const quantity = item.default_quantity
        const amount = formatToInt(item.amount)
        const subtotal = (amount * quantity) / 100

        return subtotal
      }

      return 0
    },
    createNewLink () {
      this.$store.dispatch('RESET_PAYMENT_LINK_STATE')
      this.$store.dispatch('CHANGE_STATUS', 'products-services')
      this.$router.push({ path: 'products-services' })
    },
    copy (item) {
      let element
      if (Array.isArray(this.$refs[item])) {
        element = this.$refs[item][0]
      } else {
        element = this.$refs[item]
      }
      navigator.clipboard.writeText(element.innerText)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    }
  }
}
</script>

<style>
.success-title {
  color:#30313C;
  font-size: 20px;
  font-weight: 800;
}

.success-subtitle {
  color:#2B2B2B;
  font-size: 16px;
  font-weight: 500;
}

.check-icon {
  color: var(--brand--le--primary-color--base);
  font-size: 3rem;
}

.whatsapp-button {
  font-size:14px;
  color: var(--brand--le--primary-color--base);
  font-weight:700;
}

.value-label {
  font-weight: 700;
  font-size: 16px;
  color: #070817;
}

._mode_dark .success-title, ._mode_dark .success-subtitle {
  color: #c4c6c8 !important;
}
</style>

<i18n>
{
  "pt-BR": {
    "title": "Você criou um link de",
    "subtitle": "Compartilhe como quiser para receber seus pagamentos.",
    "copy": "Copiar",
    "copied": "Copiado",
    "whatsapp": "Enviar por WhatsApp",
    "linkDetails": "Ir para detalhes do link",
    "newLink": "Criar novo link"
  },
  "en-US": {
    "title": "You have created a link of",
    "subtitle": "Share however you like to receive your payouts.",
    "copy": "Copy",
    "copied": "Copied",
    "whatsapp": "Send by WhatsApp",
    "linkDetails": "Go to link details",
    "newLink": "Create new link"
  }
}
</i18n>
